import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Alert from '../../../../../../components/global/Alert';
import { getFormikTouchedErrors } from '../../../../../../util/formik';
import WeddingEventItem from '../../../../../pro/components/WeddingEventPurchase/components/WeddingEventItem';
import { features } from '../../../../../pro/components/WeddingEventPurchase/helpers';
import useVirtualPageView from '../../../../../pro/services/analytics/useVirtualPageView';
import { EVENT_ITEM_PLAN } from '../../../../../../constants/event-items';
import { isWeddingsContent } from '../../../../../../util/album';

const propTypes = {
  className: PropTypes.string,
  values: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    phone_number: PropTypes.string,
  }).isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  eventItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    }),
  ),
  onEventItemSelected: PropTypes.func,
};

const RegistrationEventItemSelection = ({
  className,
  errors,
  touched,
  handleChange,
  eventItems,
  onEventItemSelected,
}) => {
  const classes = classNames({
    'view-register-form': true,
    [className]: !!className,
  });

  useVirtualPageView({
    title: 'Reserve Waldo for your wedding today! - Choose Plan',
    path: '/plan-selection',
  });

  const errorList = Object.values(
    getFormikTouchedErrors(errors, touched) ?? {},
  );

  const weddingEventItems = eventItems.filter(eventItem =>
    isWeddingsContent(eventItem),
  );

  const standardWeddingEvent = weddingEventItems.find(
    eventItem => !eventItem.video_guestbook_enabled,
  );
  const withVideoGuestBookWeddingEvent = weddingEventItems.find(
    eventItem => eventItem.video_guestbook_enabled,
  );

  return (
    <div className={classes}>
      <div className="wedding-event-comparison-container wedding-register-comparison-container">
        <WeddingEventItem
          skipPayment
          className="wedding-event-features-with-videoguestbook"
          eventItem={withVideoGuestBookWeddingEvent}
          title={withVideoGuestBookWeddingEvent.name}
          features={features[EVENT_ITEM_PLAN.PREMIUM]}
          onCheckout={() => {
            handleChange({
              target: {
                name: 'event_item_id',
                value: withVideoGuestBookWeddingEvent.id,
              },
            });

            onEventItemSelected();
          }}
          badgeText="Most Popular"
        />
        <WeddingEventItem
          skipPayment
          eventItem={standardWeddingEvent}
          title={standardWeddingEvent.name}
          features={features[EVENT_ITEM_PLAN.BASIC]}
          onCheckout={() => {
            handleChange({
              target: {
                name: 'event_item_id',
                value: standardWeddingEvent.id,
              },
            });

            onEventItemSelected();
          }}
        />
      </div>

      {errorList?.length > 0 && (
        <Alert type="danger" className="mb-4">
          <ul className="mb-0">
            {errorList.map(error => (
              <li key={error}>{error}</li>
            ))}
          </ul>
        </Alert>
      )}
    </div>
  );
};

RegistrationEventItemSelection.propTypes = propTypes;

export default RegistrationEventItemSelection;
